// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  PROTOCOL: 'https',

  // FOR IAMGE PATH
  // IAMGE_PATH: 'https://mynotes-be.azurewebsites.net', 
  // API IMGAGE AZURE
  // IAMGE_PATH: 'https://sfbcapi.thequantumz.com', // API URL PRODUCTION
  // IAMGE_PATH: 'https://sfbcstgapi.thequantumz.com', //API URL STAGING

  // FOR API's
  baseURL: 'infusionemrapi.thequantumz.com/api',

  // ROOT_URL: 'localhost', // LOCAL

  ROOT_URL: 'therafusion.thequantumz.com', // STAGING
};
